import React from 'react';
import PropTypes from 'prop-types';
import useModalOutsideClick from '../../hooks/useModalOutsideClick';
import './ConfirmEntryModal.css'; // Import the CSS for the modal

export const ConfirmEntryModal = ({
  show,
  onClose,
  onConfirm,
  contest,
  lineup,
  totalSalary,
  salaryCap,
  isSubmitting,
  isSuccess
}) => {
  // Add the hook with the correct class name
  useModalOutsideClick(show, onClose, "overlay");

  if (!show) {
    return null; // Don't render anything if the modal is not supposed to be shown
  }

  return (
    <div className="overlay">
      <div className="confirm-dialog">
        <div className="dialog-header">
          <h2>Confirm Your Entry</h2>
          <button
            className="close-button"
            onClick={onClose}
          >
            ×
          </button>
        </div>

        <div className="dialog-content">
          <div className="contest-info">
            <h3>{contest.tournamentName}</h3>
            <div className="info-row">
              <span className="entry-fee-label">Entry Fee:</span>
              <span className="entry-fee-amount">${contest.entryFee + contest.adminFee}</span>
            </div>
          </div>

          <div className="lineup-preview">
            <h3>Lineup</h3>
            {lineup.map((slot, index) => (
              <div key={index} className="lineup-row">
                <span className={`position-label position-${slot.position.toLowerCase()}`}>
                  {slot.position === 'Cpt' ? 'Cpt*' : slot.position}
                </span>
                <span className="player-name">{slot.player?.name || 'Empty'}</span>
                <span className="salary">${slot.player?.salary || 0}</span>
              </div>
            ))}
            <div className="total-row">
              <span>Total Salary:</span>
              <span>${totalSalary} / ${salaryCap}</span>
            </div>
          </div>

          <div className="confirm-entry-modal-captain-bonus-info">
            *Captain's cashes count as tiebreaker.
          </div>
        </div>

        <div className="dialog-actions">
          <button
            className="confirm-btn"
            onClick={onConfirm}
            disabled={isSubmitting || isSuccess}
          >
            {isSuccess ? (
              <div className="confirm-check">✓</div>
            ) : isSubmitting ? (
              <div className="confirm-spinner"></div>
            ) : (
              "Confirm Entry"
            )}
          </button>
          <button
            className="cancel-btn"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Edit Lineup
          </button>
        </div>
      </div>
    </div>
  );
};

// Add PropTypes for better component documentation and validation
ConfirmEntryModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  contest: PropTypes.shape({
    tournamentName: PropTypes.string,
    entryFee: PropTypes.number,
    salaryCap: PropTypes.number, // Added salaryCap here as well
  }).isRequired,
  lineup: PropTypes.arrayOf(PropTypes.shape({
    position: PropTypes.string,
    player: PropTypes.shape({
      name: PropTypes.string,
      salary: PropTypes.number,
    }),
  })).isRequired,
  totalSalary: PropTypes.number.isRequired,
  salaryCap: PropTypes.number.isRequired,
  isSubmitting: PropTypes.bool,
  isSuccess: PropTypes.bool,
};

// Add default prop value
ConfirmEntryModal.defaultProps = {
  isSubmitting: false,
  isSuccess: false,
};
